module.exports = __webpack_public_path__ + "img/wz11.24e91123.png";